import { Colors } from "../../../../styles/theme";
import platformStyles from "../Platform/Platform.styles";

const styles = {
  FAQ_container: {
    ...platformStyles.Platform_container,
    backgroundColor: Colors.background,
  },
  FAQ_list: {
    width: "100%",
    maxWidth: "none",
    boxSizing: "border-box",
    mt: 4,
    px: { xs: 1, sm: 3, md: 5 },
    "@media (max-width:600px) and (max-height:750px)": {
      px: 0,
    },
  },
};

export default styles;
